export interface FrameworkSection {
  id: string;
  label: string;
  placeholder?: string;
  description?: string;
}

export interface FrameworkTemplate {
  sections: FrameworkSection[];
}

export const FRAMEWORK_TEMPLATES = {
  'career-progress': {
    sections: [
      { id: 'reflection', label: 'Reflection', placeholder: 'Share your overall thoughts and insights...', description: 'Reflect on your overall experience during this period.' },
      { id: 'achievements', label: 'Key Achievements', placeholder: 'What were your main accomplishments?', description: 'List your key achievements and successes.' },
      { id: 'challenges', label: 'Challenges Faced', placeholder: 'What obstacles did you encounter?', description: 'Describe the main challenges and how you addressed them.' },
      { id: 'learnings', label: 'Key Learnings', placeholder: 'What did you learn from this period?', description: 'Document important lessons and insights gained.' },
      { id: 'next-steps', label: 'Next Steps', placeholder: 'What are your next actions?', description: 'Plan your next steps and future goals.' }
    ]
  },
  'personal-growth': {
    sections: [
      { id: 'reflection', label: 'Reflection', placeholder: 'Share your overall thoughts and insights...', description: 'Reflect on your overall experience during this period.' },
      { id: 'growth-areas', label: 'Growth Areas', placeholder: 'What areas have you grown in?', description: 'Identify areas where you have developed and improved.' },
      { id: 'insights', label: 'Personal Insights', placeholder: 'What have you learned about yourself?', description: 'Document key realizations and self-discoveries.' },
      { id: 'habits', label: 'Habits & Routines', placeholder: 'What habits have helped or hindered you?', description: 'Reflect on your daily practices and their impact.' },
      { id: 'goals', label: 'Personal Goals', placeholder: 'What personal goals do you want to set?', description: 'Set meaningful goals for your continued growth.' }
    ]
  },
  'start-stop-continue': {
    sections: [
      { id: 'reflection', label: 'Reflection', placeholder: 'Share your overall thoughts and insights...', description: 'Reflect on your overall experience during this period.' },
      { id: 'start', label: 'Start Doing', placeholder: 'What should you start doing?', description: 'New practices or habits that would benefit your growth.' },
      { id: 'stop', label: 'Stop Doing', placeholder: 'What should you stop doing?', description: 'Activities or habits that may be hindering your progress.' },
      { id: 'continue', label: 'Continue Doing', placeholder: 'What should you continue doing?', description: 'Effective practices that you should maintain.' }
    ]
  },
  'mad-sad-glad': {
    sections: [
      { id: 'reflection', label: 'Reflection', placeholder: 'Share your overall thoughts and insights...', description: 'Reflect on your overall experience during this period.' },
      { id: 'mad', label: 'Mad (Frustrations)', placeholder: 'What frustrated or challenged you?', description: 'Identify areas of frustration or challenges you faced.' },
      { id: 'sad', label: 'Sad (Disappointments)', placeholder: 'What disappointed you?', description: 'Reflect on disappointments or unmet expectations.' },
      { id: 'glad', label: 'Glad (Achievements)', placeholder: 'What made you happy or proud?', description: 'Celebrate achievements and positive experiences.' }
    ]
  },
  'custom': {
    sections: [
      { id: 'reflection', label: 'Reflection', placeholder: 'Share your thoughts and insights...', description: 'Reflect on your experiences and learnings.' }
    ]
  }
} as const; 